import React from "react";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

import lgBanner1 from "../../Images/4 Shampoo.jpg";
import lgBanner2 from "../../Images/facewash web slider pc.png";
import lgBanner4 from "../../Images/ebay web slider pc.png";
import lgBanner6 from "../../Images/ebay-facewash-pc.png";
import lgBanner7 from "../../Images/Rose-Jam-pc-copy.jpg";
import lgBanner8 from "../../Images/fw-pc-banner.jpg";

import mbBanner1 from "../../Images/4 Shampoo 2.png";
import mbBanner2 from "../../Images/facewash  web slider modile.png";
import mbBanner4 from "../../Images/ebay web slider model 4-9.psd 1.png";
import mbBanner6 from "../../Images/ebay-facewash-mb.png";
import mbBanner7 from "../../Images/Rose-Jam-mobile-copy.jpg";
import mbBanner8 from "../../Images/fw-mb-banner.jpg";

import { Link } from "react-router-dom";
import dayjs from "dayjs";

const Banner = () => {
  const isDesktop = window.innerWidth > 992;

  const banner01 = isDesktop ? lgBanner1 : mbBanner1;
  const banner02 = isDesktop ? lgBanner2 : mbBanner2;
  const banner04 = isDesktop
    ? "https://luvit.com.bd/wp-content/uploads/2025/12/Ebay-1300x339.jpg"
    : "https://luvit.com.bd/wp-content/uploads/2025/12/Ebay.jpg-2.jpg";
  const banner06 = isDesktop ? lgBanner6 : mbBanner6;
  const banner07 = isDesktop
    ? "https://luvit.com.bd/wp-content/uploads/2024/05/milk-facewash-1300x339.png"
    : "https://luvit.com.bd/wp-content/uploads/2026/02/200px-400-px-1.png";
  const banner08 = isDesktop ? lgBanner8 : mbBanner8;

  const banner09 = isDesktop
    ? "https://i.ibb.co.com/xqjT4Qg8/ebay-banner-desktop-1.png"
    : "https://luvit.com.bd/wp-content/uploads/2024/05/ebay-banner-mobile-1.2-800-400.png";
  const banner10 = isDesktop
    ? "https://i.ibb.co.com/h12mSc7B/ebay-banner-Desktop.png"
    : "https://luvit.com.bd/wp-content/uploads/2026/06/ebay-banner-mobile-800-400.png";

  // ⏳ Future Offer Logic (kept as comment if needed later)
  const currentDate = dayjs().tz("Asia/Dhaka");
  const offerStartTime = dayjs.tz("2025-12-31 23:59:00", "Asia/Dhaka");
  const offerEndTime = dayjs.tz("2026-01-03 23:59:00", "Asia/Dhaka");
  const offerValidity =
    currentDate.isAfter(offerStartTime) && currentDate.isBefore(offerEndTime);

  return (
    <section aria-label="Promotional Banners">
      <Swiper
        spaceBetween={0}
        effect="fade"
        navigation={isDesktop}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={window.innerWidth < 700 ? false : { clickable: true }}
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        className="mySwiper h-auto"
      >
        {/* ✅ Banner #1 */}
        {/* {offerValidity && (
          <SwiperSlide>
            <figure className="relative w-full">
              <Link
                to="/shop"
                title="Shop Face Wash Collection"
                className="block h-[200px] lg:h-[500px]"
              >
                <img
                  src={banner09}
                  alt="Gentle Face Wash for smooth and glowing skin"
                  width={isDesktop ? 1920 : 800}
                  height={isDesktop ? 500 : 400}
                  className="w-full h-auto"
                  loading="lazy"
                />
              </Link>
            </figure>
          </SwiperSlide>
        )} */}

        {/* ✅ Banner #3 */}
        <SwiperSlide>
          <figure>
            <Link
              to="/shop"
              title="Explore All Products in Shop"
              className="block h-[200px] lg:h-[500px] "
            >
              <img
                src={banner10}
                alt="Exclusive Beauty Products at Best Price"
                width={isDesktop ? 1920 : 800}
                height={isDesktop ? 500 : 400}
                className="w-full h-auto"
                loading="lazy"
              />
            </Link>
          </figure>
        </SwiperSlide>

        {/* <SwiperSlide>
          <figure className="relative w-full">
            <Link
              to="/product-category/face wash"
              title="Shop Face Wash Collection"
              className="block h-[200px] lg:h-[500px]"
            >
              <img
                src={banner08}
                alt="Gentle Face Wash for smooth and glowing skin"
                width={isDesktop ? 1920 : 800}
                height={isDesktop ? 500 : 400}
                className="w-full h-auto"
                loading="lazy"
              />
            </Link>
          </figure>
        </SwiperSlide> */}

        {/* ✅ Banner #2 */}
        <SwiperSlide>
          <figure>
            <Link
              to="/product-category/hair-care"
              title="Discover Natural Hair Care Products"
              className="block h-[200px] lg:h-[500px]"
            >
              <img
                src={banner01}
                alt="Nourishing Shampoo & Hair Care Range"
                width={isDesktop ? 1920 : 800}
                height={isDesktop ? 500 : 400}
                className="w-full h-auto"
                loading="lazy"
              />
            </Link>
          </figure>
        </SwiperSlide>
        <SwiperSlide>
          <figure className="relative w-full">
            <Link
              to="/product/Milk-Brightening-Face-Wash-Earth-Beauty-and-You-100ml"
              title="Shop Face Wash Collection"
              className="block h-[200px] lg:h-[500px]"
            >
              <img
                src={banner09}
                alt="Gentle Face Wash for smooth and glowing skin"
                width={isDesktop ? 1920 : 800}
                height={isDesktop ? 500 : 400}
                className="w-full h-auto"
                loading="lazy"
              />
            </Link>
          </figure>
        </SwiperSlide>
        {/* ✅ Banner #4 */}
        {/* <SwiperSlide>
          <figure>
            <Link
              to="/product-category/face-wash"
              title="Best Face Wash for Daily Skincare"
              className="block h-[200px] lg:h-[500px]"
            >
              <img
                src={banner02}
                alt="Deep cleansing face wash for fresh skin"
                width={isDesktop ? 1920 : 800}
                height={isDesktop ? 500 : 400}
                className="w-full h-auto"
                loading="lazy"
              />
            </Link>
          </figure>
        </SwiperSlide> */}

        {/* ✅ Additional banners can be enabled later
        <SwiperSlide>
          <figure>
            <Link to="/shop" title="Shop Now">
              <img
                src={banner04}
                alt="Exclusive Online Beauty Offers"
                width={isDesktop ? 1920 : 800}
                height={isDesktop ? 500 : 400}
                className="w-full h-auto"
                loading="lazy"
              />
            </Link>
          </figure>
        </SwiperSlide> */}
      </Swiper>
    </section>
  );
};

export default Banner;
